import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { Seo } from "@/components/Seo";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="July 2026">
      <Seo title="Terms of Service | Aliwer" description="The terms that govern your access to and use of Aliwer's website, consulting services, and the BArecord and SecureDesk products." path="/terms" />
      <p className="text-sm text-fog leading-relaxed">
        These Terms of Service ("Terms") govern your access to and use of the website and
        services of Aliwer LLC ("Aliwer", "we", "us") — a Texas limited liability company
        founded, owned, and operated by Lorenzo Openito. By creating an account or using
        the site, you agree to these Terms.
      </p>

      <LegalSection n="01" title="Services">
        <p>
          Aliwer provides technology systems and cybersecurity consulting, including
          consultations, and connects clients with a network of independent professionals
          ("Partners"). The free 20-minute consultation is an introductory scoping
          session and does not by itself create a consulting engagement.
        </p>
      </LegalSection>

      <LegalSection n="02" title="Accounts">
        <p>
          You are responsible for the accuracy of the information you provide and for
          maintaining the confidentiality of your login credentials. You are responsible
          for all activity under your account.
        </p>
      </LegalSection>

      <LegalSection n="03" title="Partners — independent contractor status">
        <p>
          Partners engage with Aliwer as independent contractors, not as employees,
          agents, or joint venturers. Nothing on this platform creates an employment
          relationship. Partners are responsible for their own taxes, insurance, tools,
          and the manner and means of performing any work. Acceptance into the partner
          network is at Aliwer's discretion and may require a separate written agreement.
        </p>
      </LegalSection>

      <LegalSection n="04" title="AI products — BArecord & SecureDesk">
        <p>
          BArecord and SecureDesk process content you submit (such as communications and
          support messages) using third-party AI models to provide risk scoring, summaries,
          monitoring, and responses. You are responsible for ensuring you have the right to
          submit such content. AI outputs may contain errors and are provided for
          informational purposes; they are not legal, compliance, or security determinations
          and should be independently verified. Business customers may request a Data
          Processing Addendum governing this processing.
        </p>
      </LegalSection>

      <LegalSection n="05" title="Acceptable use">
        <p>You agree not to misuse the service, attempt to gain unauthorized access, disrupt the platform, or use it for unlawful purposes.</p>
      </LegalSection>

      <LegalSection n="06" title="Disclaimers">
        <p>
          The service and any consultation content are provided "as is" and "as
          available" without warranties of any kind, express or implied, including
          merchantability, fitness for a particular purpose, and non-infringement.
          Consulting recommendations do not guarantee any specific security or business
          outcome.
        </p>
      </LegalSection>

      <LegalSection n="07" title="Limitation of liability">
        <p>
          To the maximum extent permitted by law, Aliwer and its partners shall not be
          liable for any indirect, incidental, special, consequential, or punitive
          damages, or any loss of data, revenue, or profits, arising from your use of the
          service.
        </p>
      </LegalSection>

      <LegalSection n="08" title="Indemnification">
        <p>
          You agree to indemnify and hold harmless Aliwer from claims arising out of your
          use of the service or your violation of these Terms.
        </p>
      </LegalSection>

      <LegalSection n="09" title="Governing law">
        <p>
          These Terms are governed by the laws of the State of Texas, without regard to
          its conflict-of-laws principles. Venue for any dispute shall lie in the state
          or federal courts located in Texas.
        </p>
      </LegalSection>

      <LegalSection n="10" title="Changes">
        <p>We may update these Terms from time to time. Continued use of the service after changes constitutes acceptance of the revised Terms.</p>
      </LegalSection>

      <LegalSection n="11" title="Contact">
        <p>
          Aliwer LLC<br />
          Registrant / Owner: Lorenzo Openito (Founder &amp; CEO)<br />
          300 State Street, Unit 92532, Southlake, TX 76092<br />
          Email: aliwer.usa@gmail.com<br />
          Phone: 440-463-9002 · 817-993-9336
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
